import { r as l, i as c, h as t, H as n, g as b, o as d } from "./main-bb89b2f2.js";
import "vue";
const h = '*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.absolute{position:absolute}.relative{position:relative}.block{display:block}.flex{display:flex}.hidden{display:none}:host{display:block}.breadcrumb{background-color:var(--color-neutral-steel-100);min-height:38px;padding-bottom:6px;padding-top:6px;position:relative}.breadcrumb:after,.breadcrumb:before{background-color:var(--color-neutral-steel-100);content:"";height:100%;position:absolute;top:var(--spacing-0);width:50vw;z-index:-1}.breadcrumb:before{left:auto;right:50%}.breadcrumb:after{left:50%;right:auto}.breadcrumb-wrapper{display:flex;overflow:hidden}.breadcrumb-scroll-container{-webkit-overflow-scrolling:touch;align-items:center;display:flex;justify-content:flex-start;overflow-x:auto;overflow:-moz-scrollbars-none;scroll-behavior:smooth;scroll-padding-left:0;scroll-snap-type:x mandatory;scrollbar-width:none;white-space:nowrap}.breadcrumb-scroll-container::-webkit-scrollbar{display:none}.breadcrumb-item{align-items:center;color:var(--color-neutral-steel-800);display:flex;font-size:var(--copytext-font-size-extra-small-noctx);line-height:var(--copytext-line-height-extra-small-noctx);min-height:18px;scroll-snap-align:start;scroll-snap-stop:always;white-space:nowrap}.breadcrumb-item--hidden{display:none}.breadcrumb-arrow-icon{margin-left:5px;margin-right:5px}@media (min-width:992px){.breadcrumb-item{min-height:24px}.breadcrumb-arrow-icon{margin-left:13px;margin-right:6px}}@media (max-width:991px){.breadcrumb{align-items:center;display:flex}}.visible{visibility:visible}.invisible{visibility:hidden}.static{position:static}.resize{resize:both}', m = h, u = class {
  constructor(e) {
    l(this, e), this.listOfItems = [], this.getItems = () => {
      this.listOfItems = Array.from(this.hostElement.querySelectorAll("patternlib-breadcrumb-website-item"));
    }, this.collapseBreadcrumbItem = () => {
      const i = this.listOfItems[this.itemCounter];
      i !== void 0 && (i.setAttribute("is-visible", "false"), this.itemCounter++);
    }, this.itemCounter = 1, this.isMobile = !1, this.breakpoint = "", this.allFits = !1, this.isBreadcrumbVisible = !1;
  }
  /**
   * Listens to the window resize event and retriggeres rendering
   */
  restartCollapsing() {
    clearTimeout(this.resizeTimer), this.resizeTimer = setTimeout(() => {
      this.isMobile && (this.allFits = !0, this.isBreadcrumbVisible = !0, this.isTouchDevice() && this.scrollToElement()), this.itemCounter = 1, this.listOfItems.forEach((e) => {
        e.setAttribute("is-visible", "true");
      });
    }, 100);
  }
  componentDidLoad() {
    this.isMobile = this.checkScreenSize(), this.getItems(), !this.isMobile || !this.isTouchDevice() ? this.scrollContainer.scrollWidth > this.breadcrumbWrapper.offsetWidth - 30 ? this.collapseBreadcrumbItem() : this.allFits = !0 : this.allFits = !0, this.isMobile && this.isTouchDevice() && (this.scrollToElement(), this.isBreadcrumbVisible = !0);
  }
  componentDidUpdate() {
    !this.isMobile || !this.isTouchDevice() ? (this.itemCounter == 1 && this.scrollContainer.scrollWidth < this.breadcrumbWrapper.offsetWidth - 30 && (this.allFits = !0), this.scrollContainer.scrollWidth <= this.breadcrumbWrapper.offsetWidth - 30 && (this.isBreadcrumbVisible = !0), this.scrollContainer.scrollWidth > this.breadcrumbWrapper.offsetWidth - 30 && (this.allFits = !1, this.collapseBreadcrumbItem())) : this.isBreadcrumbVisible = !0;
  }
  connectedCallback() {
    const e = document.documentElement, i = "breakpoint", s = {
      attributes: !0
    }, o = (a) => {
      const r = d(i, a);
      r !== null && (this.isMobile = this.checkScreenSize(), this.breakpoint = r);
    };
    typeof window.MutationObserver == "function" && (this.observer = new MutationObserver(o), this.observer.observe(e, s));
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  // Switching to desktop view at 992px requires an extra breakpoint in the header
  checkScreenSize() {
    return c(0, 992);
  }
  isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  }
  scrollToElement() {
    let e = 0;
    this.listOfItems.forEach((i) => {
      e += i.offsetWidth;
    }), this.scrollContainer.offsetWidth < e && this.scrollContainer.scrollTo({
      top: 0,
      // hint: we want horizontal scrolling only, therefore scrollIntoView() can't be used!
      left: this.scrollContainer.offsetLeft + e,
      behavior: "auto"
      // "smooth", "instant", "auto" (computed value)
    });
  }
  render() {
    return t(n, { key: "278ac18118fe4b065254f6eb5e93abd0b83b8c1b" }, t("div", { key: "57235eabd4ac82e97cdc570d5f76f39a14be4de9", class: {
      breadcrumb: !0,
      "is-touch-device": this.isTouchDevice()
    } }, t("div", { key: "8749b75c8d700571573617a307da6ee6d2fd00d6", class: {
      "breadcrumb-wrapper": !0,
      invisible: !this.isBreadcrumbVisible
    }, ref: (e) => {
      this.breadcrumbWrapper = e;
    } }, t("div", { key: "db0b78acb73d2d8e2fc878d7d9b331eb4ac9a6f2", class: "breadcrumb-scroll-container", ref: (e) => {
      this.scrollContainer = e;
    } }, t("slot", { key: "cdcd557349de30691f8ff3ef2784785011878b8f", name: "bu-item" }), t("div", { key: "de4caff4f50c5c0496f20eb30ee47bcc0e0f2f5e", class: {
      "breadcrumb-item": !0,
      "breadcrumb-item--hidden": this.allFits
    } }, "...", t("div", { key: "4a501860ac2204bf0290a488c1d8f5a9c0230618", class: "breadcrumb-arrow-icon" }, t("patternlib-icon", { key: "668d62431273228033bac92ec084fcb1b0715dee", iconName: "arrow-right", size: "16px" }))), t("slot", { key: "a720999689c63b5c7a7cc43a3741a89de8ebd9e7" })))));
  }
  get hostElement() {
    return b(this);
  }
};
u.style = m;
export {
  u as patternlib_breadcrumb_website
};
